import React, { createContext, useContext, useState, useRef, useCallback, useEffect } from "react";
import axiosInstance from "../Config/axios";
import { Toast } from "primereact/toast";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";

const ForgetPasswordContext = createContext();
export const useForgetPassword = () => useContext(ForgetPasswordContext);

export const ForgetPasswordProvider = ({ children }) => {
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");


// for cancel ForgetPasswords 
const functionSendOTP = async (payload) => {
  setEmail("");
  localStorage.clear();

  try {
    const response = await axiosInstance.post(
      `/customer/forgot-password/send-otp/`,
      payload,
    );

    setEmail(payload.email);

    Swal.fire({
      icon: "success",
      title: "OTP Sent",
      text: response.data?.message || "OTP sent to your email successfully.",
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C", 
    });

    navigate('/verify-otp')

    return response.data;
  } catch (err) {
    setEmail("");
    const errorDetail = err.response?.data?.detail || "Failed to sent OTP";
    Swal.fire({
      icon: "error",
      title: "Error",
      text: errorDetail,
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C", 
    });
    return null;
  }
};


// for cancel ForgetPasswords 
const functionVerifyOTP = async (payload) => {

  try {
    const response = await axiosInstance.post(
      `/customer/forgot-password/verify-otp/`,
      payload,
    );
    localStorage.setItem("verify_otp_token", response.data?.token)
    Swal.fire({
      icon: "success",
      title: "OTP Verified",
      text: response.data?.message || "OTP verified successfully.",
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C", 
    });
    navigate('/reset-password')
    
    return response.data;
  } catch (err) {
    setEmail("");
    const errorDetail = err.response?.data?.detail || "Failed to sent OTP";
    Swal.fire({
      icon: "error",
      title: "Error",
      text: errorDetail,
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
    });
    return null;
  }
};


// for cancel ForgetPasswords 
const functionResetPassWord = async (payload) => {

  const token = localStorage.getItem("verify_otp_token");

  try {
    const response = await axiosInstance.post(
      `/customer/forgot-password/reset/`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

    );
     localStorage.clear();
    Swal.fire({
      icon: "success",
      title: "Password Reset Successfully!",
      text: response.data?.message || "Password Reset successfully.",
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
    });
    setEmail("");
    navigate('/login')
    return response.data;
  } catch (err) {
    setEmail("");
    const errorDetail = err.response?.data?.detail || "Failed to sent OTP";
    Swal.fire({
      icon: "error",
      title: "Error",
      text: errorDetail,
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
    });
    return null;
  }
};

  return (
    <ForgetPasswordContext.Provider value={{loading, email, functionSendOTP, functionVerifyOTP, functionResetPassWord}}>
      
      {children}
    </ForgetPasswordContext.Provider>
  );
};
